import { cn } from "../../utils/cn";
import { formatDateTime } from "../../utils/helper";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";
import { FleetrifyModal } from "../Modal/modal";
import TransactionAmountCell from "./TransactionAmountCell";

interface TableData {
  id: string;
  amount: string;
  description: string;
  status: string;
  date: string;
  provider_fee?: number;
  platform_fee?: number;
  total_fee?: number;
  total_debit?: number;
}

interface TransactionHistoryTableFullProps {
  transactions: TableData[];
  isLoading: boolean;
  total?: number;
  currentPage?: number;
  lastPage?: number;
  onPageChange?: (page: number) => void;
}

const TransactionHistoryTableFull: React.FC<
  TransactionHistoryTableFullProps
> = ({
  transactions,
  isLoading,
  total = 0,
  currentPage = 1,
  lastPage = 1,
  onPageChange,
}) => {
  const columns: Column[] = [
    {
      label: "S/N",
      key: "sn",
      sortable: false,
      render: (_: any, row: any) => {
        const index = transactions.indexOf(row);
        return (currentPage - 1) * 10 + index + 1;
      },
    },
    // { label: "ID", key: "id", sortable: false },
    {
      label: "Amount",
      key: "amount",
      sortable: true,
      render: (value, row) => (
        <TransactionAmountCell amount={value} totalFee={row?.total_fee} />
      ),
    },
    { label: "Description", key: "description", sortable: false },
    {
      label: "Status",
      key: "status",
      sortable: true,
      render: (value) => (
        <span
          className={cn(
            "px-3 py-1 rounded-full text-xs font-medium",
            value === "success"
              ? "bg-green-100 text-green-700 border border-green-300"
              : value === "pending"
              ? "bg-orange-100 text-orange-700 border border-orange-300"
              : value === "In-Transit"
              ? "bg-blue-100 text-blue-700 border border-blue-300"
              : "bg-red-100 text-red-700 border border-red-300"
          )}
        >
          {value}
        </span>
      ),
    },
    {
      label: "Date",
      key: "created_at",
      render: (value) => formatDateTime(value),
    },
  ];
  console.log(transactions)

  return (
    <div>
      <FleetrifyCustomTable
        tableClassName="!rounded-none"
        data={transactions} // ✅ must be an array!
        columns={columns}
        isLoading={isLoading}
        checkbox={false}
        pageSize={10}
        total={total}
        currentPage={currentPage}
        lastPage={lastPage}
        setCurrentPage={(page) => {
          console.log("Change to page:", page);
          if (onPageChange) onPageChange(page);
        }}
      />

      {/* ✅ Transaction Detail Modal */}
      <FleetrifyModal
        isOpen={false}
        onClose={() => {}}
        title="Transaction Details"
        className="max-w-lg h-fit"
      >
        <div className="space-y-4 p-6">
          <h3 className="text-lg font-bold text-gray-900 mb-6">
            Full Record Details
          </h3>

          <div className="space-y-4">
            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Reference:
              </span>
              <span className="text-sm text-gray-900 font-medium w-[60%]">
                TXN-WLT-83920
              </span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Date:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">
                Jun 28, 2025
              </span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Type:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">Top Up</span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Status:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">Successful</span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Amount:
              </span>
              <span className="text-sm text-gray-900 font-semibold w-[60%]">
                ₦50,000.00
              </span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Payment Method:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">MasterCard</span>
            </div>

            <div className="flex items-start justify-between border-b border-dotted border-gray-300 pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Initiated By:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">
                John Doe (Client Admin)
              </span>
            </div>

            <div className="flex items-start justify-between pb-3">
              <span className="text-sm font-semibold text-[#1D1D1D] w-[40%]">
                Reason:
              </span>
              <span className="text-sm text-gray-900 w-[60%]">
                Wallet top-up for driver dispatch ops
              </span>
            </div>
          </div>
        </div>
      </FleetrifyModal>
    </div>
  );
};

export default TransactionHistoryTableFull;
